module.exports = __webpack_public_path__ + "static/media/howItWorks_step1.1bd2c125.png";